import styled from 'styled-components'

export const Wrapper = styled.div`
  button {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 0;
    border: none;
    background: transparent;
    color: #0085ff;
    font-weight: 700;
    cursor: pointer;
    transition: opacity 200ms;

    &:hover {
      opacity: 0.7;
    }
  }
`
